import { render, staticRenderFns } from "./CartRecap.vue?vue&type=template&id=ad51993c&scoped=true&"
import script from "./CartRecap.vue?vue&type=script&lang=js&"
export * from "./CartRecap.vue?vue&type=script&lang=js&"
import style0 from "./CartRecap.vue?vue&type=style&index=0&id=ad51993c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad51993c",
  null
  
)

export default component.exports